import { logout } from 'redux/actions/user.actions'
import * as adminActions from 'redux/actions/admin.actions'

const initialState = {
  users: [],
  domains: []
}

function adminReducer(state = initialState, { type, payload = {} }) {
  switch (type) {
    case adminActions.getAdminUsersSuccess.type: {
      return {
        ...state,
        users: payload.users,
        meta: payload.meta
      }
    }
    case adminActions.getAdminUserDomainsSuccess.type: {
      return {
        ...state,
        domains: payload.domains
      }
    }
    case adminActions.getAdminUsersFailure.type:
    case logout.type:
      return initialState
    default:
      return state
  }
}
export default adminReducer
